import { create, update, list } from 'src/repositories/product.repository';

export const PRODUCT_LIST_CHANGED = 'PRODUCT_LIST_CHANGED';
export const CREATED_PRODUCT = 'CREATED_PRODUCT';
export const UPDATED_PRODUCT = 'UPDATED_PRODUCT';
export const FETCHING_PRODUCT_LIST = 'FETCHING_PRODUCT_LIST';
export const FETCHED_PRODUCTS = 'FETCHED_PRODUCTS';

export const createProduct = ({ interest, fine, ...params }) => (dispatch, getState) => create({
    interest: parseFloat(interest),
    fine: parseFloat(fine),
    ...params,
}).then((res) => {
    dispatch({ type: CREATED_PRODUCT, payload: res.data });
    const { product: { productsList = {} } } = getState();
    dispatch({ type: PRODUCT_LIST_CHANGED, payload: productsList });
    return res.data;
});


export const updateProduct = (id, { interest, fine, ...params }) => (dispatch, getState) => {
    if (interest && parseFloat(interest)) {
        params.interest = parseFloat(interest);
    }
    else {
        delete params.interest;
    }
    if (fine && parseFloat(fine)) {
        params.fine = parseFloat(fine);
    }
    else {
        delete params.fine;
    }

    return update(id, params).then((res) => {
        dispatch({ type: UPDATED_PRODUCT, payload: res.data });
        const { product: { productsList = {} } } = getState();
        dispatch({ type: PRODUCT_LIST_CHANGED, payload: productsList });
        return res.data;

    });
};

export const listProducts = () => (dispatch) => {
    dispatch({ type: FETCHING_PRODUCT_LIST, payload: true });
    return list()
        .then(({ data }) => {
            dispatch({
                type: FETCHED_PRODUCTS,
                payload: data,
            });
            return data;
        })
        .finally(() => dispatch({ type: FETCHING_PRODUCT_LIST, payload: false }));
};
